import
  React
from 'react';

import {
  HFillContainerVH,
  Image,
  Text
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../../../constants';

export const SecureCheckout = (props) => {

  return (

    <HFillContainerVH
      minHeight={'50px'}
      maxHeight={'50px'}
      borderBottom={props.border}>

      <Image
        src={Icons.Lock}
        height={'16px'}
        width={'16px'}/>

      <Text
        padding={'1px 8px 0'}
        fontSize={'14px'}
        fontWeight={'bold'}
        color={CustomColors.Grey14}>

        {'Secure checkout'}
      </Text>

    </HFillContainerVH>
  );
};
